//material ui
import { Button, Drawer, IconButton } from "@material-ui/core";
import { orange } from "@material-ui/core/colors";
import CssBaseline from "@material-ui/core/CssBaseline";
import LinearProgress from "@material-ui/core/LinearProgress";
import { createMuiTheme, ThemeProvider, withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import React, { useState } from "react";
import useLocalStorageState from './hooks/useLocalStorageState';
import "./App.css";
import MenuIcon from '@material-ui/icons/Menu';
import Grid from '@material-ui/core/Grid';
//components
import Start from "./components/ui/start";
import { ReactComponent as Dota2Icon } from "./icons/dota-2.svg";
import HeroesDiagram from './components/charts/heroesDiagrams';
import MainInfo from './components/info/mainInfo';
//styles and icons
import useStyles from "./style";
import mock from './mock.json';
import { DataProvider } from "./dataProvider";

function App() {
  const isDev = process.env.NODE_ENV === 'development';
  const classes = useStyles();
  const [data, setData] = useState(isDev ? { status: "ready", ...mock } : { status: "start" });
  const [isLoading, setLoading] = useState(false);
  const [isDark, setDark] = useLocalStorageState('GGSBOT-theme', true);
  const [showMenu, setShowMenu] = useState(false);

  const [radiantPick, setRadiant] = useLocalStorageState('GGSBOT-radiantPick', {});
  const [direPick, setDire] = useLocalStorageState('GGSBOT-direPick', {});
  const [radiantName, setRadiantName] = useLocalStorageState('GGSBOT-radiantName', '')
  const [direName, setDireName] = useLocalStorageState('GGSBOT-direName', '')
  const [tournamentID, settournamentID] = useLocalStorageState('GGSBOT-tournamentID', '');
  const currentUser = (() => {
    try {
      return JSON.parse(localStorage.getItem('ggs_user')) || {};
    } catch (error) {
      return {};
    }
  })();

  const theme = React.useMemo(
    () =>
      createMuiTheme({
        palette: {
          type: isDark ? "dark" : "light",
        },
      }),
    [isDark]
  );

  const toggleDrawer = () => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setShowMenu(!showMenu);
  };

  const CustomSwitch = withStyles({
    switchBase: {
      color: "black",
      "&$checked": {
        color: orange[500],
      },
      "&$checked + $track": {
        backgroundColor: orange[500],
      },
    },
    checked: {},
    track: {},
  })(Switch);

  const CustomLinearProgress = withStyles((theme) => ({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
      borderRadius: 5,
      backgroundColor: isDark ? orange[500] : 'black',
    },
  }))(LinearProgress);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Grid container justify="center" style={{ padding: '1rem' }}>
        <Grid item spacing={2} container xs={12} alignItems="center" style={{marginBottom: '1rem'}} sx={{ ml: 'auto' }}>
          <Grid item>
            <IconButton onClick={toggleDrawer()}>
              <MenuIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <Dota2Icon
              className={classes.logoIcon}
              style={{ fill: isDark ? orange[500] : "black" }}
            />
          </Grid>
          <Grid item>
            <Typography variant="h5">GGS Bot Dota 2</Typography>
          </Grid>
          {currentUser.isAdmin && (
            <Grid item>
              <Button href="/admin" variant="outlined">Users</Button>
            </Grid>
          )}
        </Grid>
        <React.Fragment key={"left"}>
          <Drawer anchor={"left"} open={showMenu} onClose={toggleDrawer()}>
            <Start
              setData={setData}
              isLoading={isLoading}
              isDark={isDark}
              setLoading={setLoading}
              closeMenu={setShowMenu}
              startDeps={{ radiantPick, direPick, radiantName, direName, tournamentID, settournamentID, setRadiantName, setRadiant, setDireName, setDire }}
            />
          </Drawer>
        </React.Fragment>
        {!isLoading && data.status === "ready" && (
          <Grid container spacing={2} xs={12}>
            <DataProvider data={{ ...data, isDark }} >
              <Grid item xs={12}>
                <MainInfo />
              </Grid>
              <Grid item xs={12}>
                <HeroesDiagram />
              </Grid>
            </DataProvider>
          </Grid>
        )}
      </Grid>
      {isLoading && (
        <div className={classes.loading}>
          <CustomLinearProgress />
        </div>
      )}
    </ThemeProvider>
  );
}

export default App;
